import React from 'react'
import { observer } from 'mobx-react-lite'
import { View, ViewStyle } from 'react-native'

import { Text } from '../text'

interface ReviewMatchingProps {
  question: any
  branding: any
}
export const ReviewMatching = observer((props: ReviewMatchingProps) => {
  const { question, branding } = props
  const userChoiceID = question?.user_answer_choices[0]?.choice_id
  const selected = question?.question_answer_choices.find((c) => c.choice_id === userChoiceID)
  const actual = question?.question_answer_choices.find((c) => c.correct)

  if (selected) {
    const { pairs } = selected
    return (
      <View style={{ flexDirection: 'column', gap: 16, justifyContent: 'flex-start' }}>
        <View style={{ ...CHOICE_CONTAINER, flexDirection: 'row', gap: 16 }}>
          <View
            style={{
              ...CHOICE_CONTAINER,
              alignItems: 'flex-start',
              marginBottom: 0,
              flexDirection: 'column',
              alignSelf: 'flex-start',
              gap: 8,
              flex: 1,
              paddingRight: 20,
            }}
          >
            {pairs.map((pair, idx) => {
              let textColor = `${branding!.review_background_text}50`
              textColor =
                actual.pairs[idx].left === pair.left && actual.pairs[idx].right === pair.right
                  ? branding!.correct_answer
                  : branding!.incorrect_answer
              return (
                <View style={{ gap: 8, flex: 1, flexDirection: 'row', display: 'flex' }}>
                  <View>
                    <Text
                      variant="title"
                      disableLink
                      style={{ width: 20, color: textColor }}
                      text={`${idx + 1}.`}
                    />
                  </View>
                  <Text
                    disableLink
                    variant="title"
                    style={{ color: textColor }}
                    text={`${pair.left} → ${pair.right}`}
                  />
                </View>
              )
            })}
          </View>
        </View>
        {!question.correct && (
          <>
            <View style={{ ...DIVIDER, marginTop: 8, marginBottom: 8 }} />
            <Text
              disableLink
              variant="title"
              style={{ color: branding.review_background_text }}
              text="The correct matching is:"
            />
            <View style={{ ...CHOICE_CONTAINER, flexDirection: 'row', gap: 16 }}>
              <View
                style={{
                  ...CHOICE_CONTAINER,
                  alignItems: 'flex-start',
                  marginBottom: 0,
                  flexDirection: 'column',
                  alignSelf: 'flex-start',
                  gap: 8,
                  flex: 1,
                  paddingRight: 20,
                }}
              >
                {actual.pairs.map((pair, idx) => {
                  return (
                    <View style={{ gap: 8, flex: 1, flexDirection: 'row', display: 'flex' }}>
                      <View>
                        <Text
                          variant="title"
                          disableLink
                          style={{ width: 20, color: branding!.review_background_text }}
                          text={`${idx + 1}.`}
                        />
                      </View>
                      <Text
                        disableLink
                        variant="title"
                        style={{ color: branding!.review_background_text }}
                        text={`${pair.left} → ${pair.right}`}
                      />
                    </View>
                  )
                })}
              </View>
            </View>
          </>
        )}
      </View>
    )
  }
  return null
})

const DIVIDER: ViewStyle = {
  height: 1,
  backgroundColor: '#ffffff20',
  marginBottom: 20,
  width: '100%',
}
const CHOICE_CONTAINER: ViewStyle = { alignItems: 'center', flexDirection: 'row' }
